module.exports = __webpack_public_path__ + "static/img/10.ade4386.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/zh/10.png
// module id = mXfX
// module chunks = 0